import { ChangeDetectionStrategy, Component, Input } from '@angular/core';


@Component({
    selector: 'legal-terms-of-use',
    templateUrl: './terms-of-use.component.html',
    styleUrls: ['./terms-of-use.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LegalTermsOfUseComponent {

	//** Input decorator */
	@Input() content: string;
}
